module.exports = __webpack_public_path__ + "img/Logo.6f083e58.png";